import { Check } from 'lucide-react';
import { FleetGallery } from '@/components/booking/FleetGallery';
import { resolveFleetImages } from '@/data/fleetImages';
import { bt, vehClass, badgeT, featureT } from '@/i18n/bookingI18n';

export function VehicleCard({ vehicle, duration, selected, onSelect, lang = 'en' }) {
  const price = duration === '4h' ? vehicle.price4h : vehicle.price8h;
  const isSelected = selected === vehicle.name;
  const slug = vehicle.name.toLowerCase().replace(/\s+/g, '-');
  const photos = resolveFleetImages(vehicle.name, vehicle.image);

  return (
    <div
      role="button"
      tabIndex={0}
      data-testid={`vehicle-card-${slug}`}
      onClick={() => onSelect(vehicle.name)}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(vehicle.name); } }}
      className={`relative w-full text-left group rounded-2xl overflow-hidden transition-all duration-300 border cursor-pointer ${
        isSelected ? 'border-[#EE5A01] bg-[#FFF4ED]' : 'border-black/10 bg-white hover:border-[#EE5A01]/40'
      }`}
    >
      <div className="aspect-[16/10] overflow-hidden relative">
        <img src={vehicle.image} alt={vehicle.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        {vehicle.badge && (
          <span data-testid={`vehicle-badge-${slug}`} className="absolute top-3 left-3 chip-orange !text-[9px] !tracking-[0.12em] !px-2 !py-1">{badgeT(lang, vehicle.badge)}</span>
        )}
        {isSelected && (
          <div className="absolute top-3 right-3 w-8 h-8 bg-[#EE5A01] flex items-center justify-center">
            <Check className="w-5 h-5 text-white" />
          </div>
        )}
        <div className="absolute bottom-0 inset-x-0 h-20 bg-gradient-to-t from-black/50 to-transparent" />
        <div className="absolute bottom-3 left-3 z-10">
          <FleetGallery images={photos} name={vehicle.name} testid={`vehicle-photos-${slug}`} triggerClass="text-white bg-black/40 backdrop-blur px-2.5 py-1 rounded-md hover:bg-black/60" />
        </div>
      </div>
      <div className="p-4 sm:p-5">
        <div className="flex items-start justify-between gap-2 mb-2">
          <div>
            <h3 className="font-heading font-bold text-base sm:text-lg text-[#121212]">{vehClass(lang, vehicle.name)}</h3>
            <p className="font-body text-xs text-[#666666] mt-0.5">{vehClass(lang, vehicle.type)}</p>
          </div>
          <div className="text-right flex-shrink-0">
            <p className="font-heading font-black text-lg sm:text-xl text-[#EE5A01]">AED {price.toLocaleString()}</p>
            <p className="font-mono text-[10px] text-[#666666]">{duration === '4h' ? bt(lang, 'hours4') : bt(lang, 'hours8')} · {bt(lang, 'inclVat')}</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mt-3">
          {vehicle.features.map((f) => (
            <span key={f} className="font-body text-[10px] sm:text-xs text-[#555555] bg-[#F5F5F3] px-2 py-1">{featureT(lang, f)}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
